import { environment } from '../environments/environment';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MapGoogleAgmComponent } from './@theme/components/map-google-agm/map-google-agm.component';
import { AgmCoreModule } from '@agm/core';
import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import { AgmGoogleMapService } from './@core/services/googlemap.service';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { DeviceHistoryComponent } from './@theme/components/device-history/device-history.component';
import { GoogleAddressSearchComponent } from './@theme/components/google-address-search/google-address-search.component';
import { PudoDealerMapDialogComponent } from './@theme/components/pudo-dealer-map-dialog/pudo-dealer-map-dialog.component';
import { LocationsMapComponent } from './@theme/components/locations-map/locations-map.component';
import { RoutePostalcodeComponent } from './@theme/components/route-postalcode/route-postalcode.component';
import { SelectLastStopComponent } from './@theme/components/select-last-stop/select-last-stop.component';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  // Pipelines can rebuild the same package version with new translation keys.
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + encodeURIComponent(environment.appVersion) + '&reload=' + Date.now());
}

@NgModule({
  declarations: [
    MapGoogleAgmComponent,
    DeviceHistoryComponent,
    GoogleAddressSearchComponent,
    SelectLastStopComponent,
    PudoDealerMapDialogComponent,
    LocationsMapComponent,
    RoutePostalcodeComponent
  ],
  exports: [
    MapGoogleAgmComponent,
    DeviceHistoryComponent,
    GoogleAddressSearchComponent,
    SelectLastStopComponent,
    PudoDealerMapDialogComponent,
    LocationsMapComponent,
    RoutePostalcodeComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    AngularMaterialModule,
    AgmCoreModule.forRoot({
      //apiKey: 'AIzaSyBLt7OfhTfLy7DLOuB1041ouzM9ilfgYII',
      apiKey: 'AIzaSyBaFgBaZY6_AjRQXUuCDW6bZMUeZDTHQpQ',
      libraries: ['geometry', 'places'],
      language: 'en'
    }),
    AgmJsMarkerClustererModule,
    MatGoogleMapsAutocompleteModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  entryComponents: [
    MapGoogleAgmComponent,
    DeviceHistoryComponent,
    GoogleAddressSearchComponent,
    SelectLastStopComponent,
    PudoDealerMapDialogComponent,
    LocationsMapComponent,
    RoutePostalcodeComponent
  ],
  providers: [AgmGoogleMapService, { provide: LOCALE_ID, useValue: 'fr-CA' }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GoogleMapModule {}
